var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportIconDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 20.375H19.6666M9.33325 14.875H17.0833M10.6249 3.1875H5.45825V25.875H23.5416V3.1875H18.3749M10.6249 3.1875V5.25H18.3749V3.1875M10.6249 3.1875V1.125H18.3749V3.1875",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportIconDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reportIcon_dark.cb633a4c542027af11841215b2bf4d78.svg";